import { render } from "./official-logoff.vue?vue&type=template&id=686d3a6d&scoped=true&ts=true"
import script from "./official-logoff.vue?vue&type=script&lang=ts"
export * from "./official-logoff.vue?vue&type=script&lang=ts"

import "./official-logoff.vue?vue&type=style&index=0&id=686d3a6d&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-686d3a6d"]])